import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { intervalSelector } from '@store/overviewDashboard/base/selectors';
import { selector as commonSelector } from '@store/common';
import Shortcuts from './Shortcuts';
import CustomDateRangePicker from './CustomDateRangePicker';
import moment from 'moment';
import { DateContainer, DateRange } from '@components/common/date-picker-v2/styled';

const OverviewDatePicker = () => {
  const [isCustomSelected, setCustomSelected] = useState(false);
  const selectedInterval = useSelector(intervalSelector);
  const common = useSelector(commonSelector);
  const { tzOffset, features } = common;
  const { overviewDate } = features;
  const containerRef: any = useRef();

  const dateFormat = 'YYYY/MM/DD';

  return (
    <DateRange id="overview-date-picker" ref={containerRef} style={{ marginRight: '10px' }}>
      <DateContainer>
        <Shortcuts
          selectedInterval={selectedInterval}
          overviewDate={overviewDate}
          tzOffset={tzOffset}
        />
        <CustomDateRangePicker
          value={[
            moment(selectedInterval.from, dateFormat),
            moment(selectedInterval.to, dateFormat),
          ]}
          isCustomSelected={isCustomSelected}
          setCustomSelected={setCustomSelected}
          overviewDate={overviewDate}
          tzOffset={tzOffset}
          containerRef={containerRef}
        />
      </DateContainer>
    </DateRange>
  );
};

export default OverviewDatePicker;
